<template>
  <div class="account">
    <Header />
    <CallCenter />
    <Footer />
  </div>
</template>

<script>
import Header from "../../src/components/template/Header";
import Footer from "../../src/components/template/Footer";
import CallCenter from "../../src/components/CallCenter/CallCenter";

export default {
  data() {
    return {
      linkDaPagina: null,
    };
  },

  async created() {
    this.linkDaPagina = window.location.href;
  },

  metaInfo() {
    return {
      title: "Central de Atendimento | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "A Central de Atendimento Leveros Integra esclarece suas dúvidas de um jeito simples e rápido. Acompanhe seus pedidos, trocas e devoluções etc.",
        },
        { name: "robots", content: "index,follow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Central de Atendimento | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "A Central de Atendimento Leveros Integra esclarece suas dúvidas de um jeito simples e rápido. Acompanhe seus pedidos, trocas e devoluções etc.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  components: {
    Header,
    Footer,
    CallCenter,
  },
};
</script>